// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-icon svg[data-v-ecd5dfea] {\n  font-size: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
